import React from 'react';
import { Input, Typography, Form } from 'antd';
import PropTypes from 'prop-types';
import { customAppDomainValidator } from 'utils/inputValidators/inputValidators';

import './styles.less';

const { Text, Title } = Typography;

// eslint-disable-next-line react/prefer-stateless-function
class AppDomainInput extends React.Component {
  componentDidMount() {
    const { form, error } = this.props;

    if (error) {
      form.current.validateFields(['customAppDomain'], { force: true });
    }
  }

  componentDidUpdate(prevProps) {
    const { form, error } = this.props;

    if (error && error !== prevProps.error) {
      form.current.validateFields(['customAppDomain'], { force: true });
    }
  }

  render() {
    const { profileTypeId, template, value, error, onChange, form, t, onSubmit } = this.props;
    const splittedTemplate = template.split('{0}');

    const serverErrorValidator = () =>
      new Promise((resolve, reject) => {
        if (error) {
          reject(error);
        } else {
          resolve();
        }
      });

    return (
      <div className="app-domain-container">
        <Title level={4}>{t('appDomainInput.title')}</Title>
        <Text type="secondary">{t('appDomainInput.subtitle')}</Text>
        <Form
          name="customAppDomainForm"
          ref={form}
          initialValues={{ customAppDomain: value }}
          className="app-domain-container__form"
        >
          <Form.Item>
            <Text className="app-domain-container__template">{splittedTemplate[0]}</Text>
            <Form.Item
              name="customAppDomain"
              rules={[
                { required: true, message: t('appDomainInput.requiredError') },
                { validator: customAppDomainValidator },
                { validator: serverErrorValidator },
              ]}
              noStyle
            >
              <Input
                className="app-domain-container__input"
                type="text"
                placeholder={t('appDomainInput.placeholder')}
                onChange={() => onChange('customAppDomain')}
                onPressEnter={onSubmit}
                autoFocus
              />
            </Form.Item>
            <Text className="app-domain-container__template">{splittedTemplate[1]}</Text>
          </Form.Item>
        </Form>
        <Text>
          {t('appDomainInput.dontKnowYourAppDomain')}{' '}
          <a
            href={`${t('urls.appDocUrl', { provider: profileTypeId.toLowerCase() })}#application`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('appDomainInput.findYourAppDomain')}
          </a>
        </Text>
      </div>
    );
  }
}

AppDomainInput.propTypes = {
  profileTypeId: PropTypes.string.isRequired,
  template: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  form: PropTypes.shape({
    current: PropTypes.shape({
      validateFields: PropTypes.func.isRequired,
    }),
  }),
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

AppDomainInput.defaultProps = {
  value: '',
  error: '',
  onChange: () => {},
  form: React.createRef(),
};

export default AppDomainInput;
